import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiComponentsCoreModule } from '@domgen/dgx-fe-components-core';
import { SkyCoverExclusionsComponent } from './sky-covers-exclusions.component';

@NgModule({
  imports: [CommonModule, SharedUiComponentsCoreModule],
  declarations: [SkyCoverExclusionsComponent],
  exports: [SkyCoverExclusionsComponent],
})
export class SkyCoversExclusionsModule {}
